import CustomStore from "devextreme/data/custom_store";
import axios from "axios";
import { getLoadOptionsParams } from "../utils/loadoptions-params";

// A function that takes the server URL as an argument allowing us to use it for different endpoints and returns a new DevExtreme CustomStore instance
// We use this store for DataGrid data sources (so far)
const createCustomStore = (url, additionalFilter) => {
  return new CustomStore({
    cacheRawData: false,
    key: "id",
    load: async loadOptions => {
      return await axios
        .get(url + getLoadOptionsParams(loadOptions), {
          params: additionalFilter
        })
        .then(response => {
          return {
            data: response.data.data,
            totalCount: response.data.totalCount,
            summary: response.data.summary
          };
        })
        .catch(error => {
          let errorMessage =
            error.response && error.response.data
              ? error.response.data
              : error.message;
          throw new Error(errorMessage);
        });
    },
    insert: async data => {
      return await axios
        .post(url, data)
        .then(response => ({ data: response.data }))
        .catch(error => {
          let errorMessage =
            error.response && error.response.data
              ? error.response.data
              : error.message;
          throw new Error(errorMessage);
        });
    },
    remove: async key => {
      return await axios
        .delete(`${url}/${key}`)
        .then(response => ({ data: response.data }))
        .catch(error => {
          let errorMessage =
            error.response && error.response.data
              ? error.response.data
              : error.message;
          throw new Error(errorMessage);
        });
    }
  });
};

export default createCustomStore;
